


































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { Permission } from "@/shared/types";
import * as routes from "@/employer/route-names";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component
export default class EmployeesNavigation extends Vue {
  custodianSettingStore = useCustodianSettingsStore();
  rolePermissionsStore = useRolePermissionsStore();

  routes = routes;
  activeTab = null;

  mounted (): void {
    this.custodianSettingStore.getEmployerCustodian();
    this.activeTab = this.$route.name;
  }

  navigationClicked (pathName: string) {
    this.activeTab = pathName;
    this.$emit("navigation-tab-item-clicked", {
      name: this.$route.name,
      path: pathName
    });
  }

  get displayEmployerCensusUploadLink (): boolean {
    return this.rolePermissionsStore.userHasPermission(Permission.CensusWrite);
  }

  get hasInviteDateWritePermission (): boolean {
    return this.rolePermissionsStore.userHasPermission(Permission.InviteDateWrite);
  }

  get displayEmployeeIdUpdateLink (): boolean {
    return this.rolePermissionsStore.userHasPermission(Permission.EmployeeIdUpdate);
  }
}

